import React, { ReactElement, SetStateAction } from 'react';
import { Editor } from 'react-draft-wysiwyg';

import { toolbarConfig } from '../../../utils/text-editor-util';

import './rich-text-editor.scss';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

type Props = {
  editorState?: object;
  setEditorState: React.Dispatch<SetStateAction<object | undefined>>;
  disabled?: boolean;
};

const RichTextEditor = ({ editorState, setEditorState, disabled = false }: Props): ReactElement => {
  return (
    <Editor
      editorState={editorState}
      onEditorStateChange={setEditorState}
      toolbar={toolbarConfig}
      wrapperClassName="rich-text-editor__wrapper"
      editorClassName="rich-text-editor__editor"
      toolbarClassName="rich-text-editor__toolbar"
      readOnly={disabled}
    />
  );
};

export default RichTextEditor;
